import { useMemo } from "react";

/**
 * Deterministic password strength meter — no external library. Rewards length
 * and character-class variety; caps at 4 so the UI is a discrete 0–4 bar.
 */
function scorePassword(pw) {
  if (!pw) return { score: 0, label: "" };
  let s = 0;
  if (pw.length >= 8) s += 1;
  if (pw.length >= 12) s += 1;
  if (/[A-Z]/.test(pw) && /[a-z]/.test(pw)) s += 1;
  if (/\d/.test(pw)) s += 0.5;
  if (/[^A-Za-z0-9]/.test(pw)) s += 1;
  if (pw.length < 8) s = Math.min(s, 0.9);
  // Always at least "Weak" (1) once the user has typed something — never
  // show a blank label under the bar.
  const rounded = Math.max(1, Math.min(4, Math.round(s)));
  const label = ["", "Weak", "Fair", "Good", "Strong"][rounded];
  return { score: rounded, label };
}

const COLORS = ["#e2e8f0", "#f87171", "#f59e0b", "#84cc16", "#059669"];

export default function PasswordStrength({ password }) {
  const { score, label } = useMemo(() => scorePassword(password || ""), [password]);
  if (!password) return null;
  return (
    <div className="mt-1" data-testid="password-strength">
      <div className="flex gap-1">
        {[1, 2, 3, 4].map(i => (
          <div key={i} className="h-1 flex-1 rounded-full transition-colors" style={{ background: i <= score ? COLORS[score] : "#e2e8f0" }} />
        ))}
      </div>
      <div className="mt-1 text-[10px] uppercase tracking-widest font-semibold" style={{ color: score >= 3 ? "#059669" : score >= 2 ? "#b45309" : "#dc2626" }}>
        {label}
      </div>
    </div>
  );
}
